/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Fancy_Vast_Otter_PurrInputs */

const fr_fancy_vast_otter_purr = /** @type {(inputs: Fancy_Vast_Otter_PurrInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prochaine date de prélèvement`)
};

/**

* @param {Fancy_Vast_Otter_PurrInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const fancy_vast_otter_purr = /** @type {((inputs?: Fancy_Vast_Otter_PurrInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Fancy_Vast_Otter_PurrInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_fancy_vast_otter_purr(inputs)
});